import _max from 'lodash/max';
import { DEFAULT_ROW_HEIGHT } from '../../virtualizedInputTable.constants';
export var getHeightForRow = function getHeightForRow(rowHeights, rowIndex) {
  return _max([rowHeights[rowIndex], DEFAULT_ROW_HEIGHT]);
};
export var setHeightOfRow = function setHeightOfRow(_ref) {
  var rowHeights = _ref.rowHeights,
    rowHeight = _ref.rowHeight,
    rowIndex = _ref.rowIndex,
    listRef = _ref.listRef;
  // eslint-disable-next-line no-param-reassign
  rowHeights[rowIndex] = rowHeight;
  listRef.current.resetAfterIndex(rowIndex);
};